import Vue from 'vue'
import toast from './toast'
import loading from './loading'
import daidiLoading from './daidi-loading'

Vue.use({
  // 在Vue中使用插件，需要一个提供install方法的对象
  install(vm) {
    vm.prototype.$toast = toast
    vm.prototype.$loading = loading
    vm.prototype.$daidiLoading = daidiLoading
  }
})
